export default "https://cdn-static.gokick.com/assets/316c05c5b819a67ca00dcd3ca58b5d19adb19ecb/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";